import SDASingleView from './SDASingleView';
export default SDASingleView;
